var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "152px",
    height: "152px",
    viewBox: "0 0 152 152",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8B3DFD6B-645E-4F4D-AAAA-DF1C6F7AFB19") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plan-activated",
    transform: "translate(-465.000000, -146.000000)",
    fill: "#5CBF3D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M487.207792,168.374446 C457.597403,198.009473 457.597403,246.215784 487.207792,275.850811 C500.433766,289.08779 517.41039,296.397764 534.781818,297.780732 C543.072727,298.373432 551.561039,297.780732 559.654545,295.805063 C572.485714,292.643994 584.724675,285.926721 594.792208,275.850811 C624.402597,246.215784 624.402597,198.009473 594.792208,168.374446 C564.984416,138.541851 516.818182,138.541851 487.207792,168.374446 Z M527.397906,251 L502,225.267606 L507.643979,219.549296 L527.397906,239.56338 L573.356021,193 L579,198.71831 L527.397906,251 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/greenTick.4c7fab1b0694c4497c442c5bcec3ba76.svg";
export { ForwardRef as ReactComponent };